import { useEffect, useRef } from "react";

/**
 * Embeds a Paperform inline using the official embed script.
 * The script is loaded once per page; subsequent mounts reuse it and
 * Paperform's script auto-detects the new `data-paperform-id` div.
 *
 * Usage: <PaperformEmbed formId="ywbjco9t" />
 */
export default function PaperformEmbed({ formId, className = "" }) {
    const containerRef = useRef(null);

    useEffect(() => {
        const SRC = "https://paperform.co/__embed.min.js";
        const existing = document.querySelector(`script[src="${SRC}"]`);

        if (!existing) {
            const script = document.createElement("script");
            script.src = SRC;
            script.async = true;
            document.body.appendChild(script);
        } else if (window.Paperform && typeof window.Paperform.mount === "function") {
            // Re-scan the DOM if Paperform is already loaded (SPA route changes).
            window.Paperform.mount();
        }
    }, [formId]);

    return (
        <div
            ref={containerRef}
            className={className}
            data-testid="paperform-embed-wrapper"
        >
            <div data-paperform-id={formId} data-testid={`paperform-${formId}`} />
        </div>
    );
}
